const NON_ASCII = /[^\x00-\x7f]/g;

/**
 * The headset reads managementConfig.json with Encoding.ASCII, so escaping every byte
 * above 127 is what lets its JSON parser restore the original characters.
 */
export function toAsciiSafeJson(config: Record<string, unknown>): string {
  return JSON.stringify(config, null, 2).replace(
    NON_ASCII,
    (character) => `\\u${character.charCodeAt(0).toString(16).padStart(4, "0")}`,
  );
}
